import { lazy, Suspense, useEffect, useRef, useState } from "react";
/// Components
import { connect, useDispatch } from "react-redux";
import { Route, Switch, withRouter } from "react-router-dom";
import Index from "./jsx/index";
// action
import { checkAutoLogin } from "./services/AuthService";
import { isAuthenticated } from "./store/selectors/AuthSelectors";
/// Style
import { useRecoilState } from "recoil";
import "./css/style.css";
import {
  checkTokenInterval,
  TOKEN_VERIFICATION_STATUS,
} from "./services/ShinryuService";
import {
  getLocalStorage,
  removeLocalStorage,
  userIdState,
  userIsLoginState,
} from "./store/recoil";
import "./vendor/bootstrap-select/dist/css/bootstrap-select.min.css";

const SignUp = lazy(() => import("./jsx/pages/Registration"));
const ForgotPassword = lazy(() => import("./jsx/pages/ForgotPassword"));
const Login = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(import("./jsx/pages/Login")), 300);
  });
});
function App(props) {
  const dispatch = useDispatch();
  const [userIsLogin, setUserIsLogin] = useRecoilState(userIsLoginState);
  const [userId, setUserId] = useRecoilState(userIdState);
  const [isConnectionUnavailable, setIsConnectionUnavailable] = useState(false);
  const verificationInFlight = useRef(false);
  const verificationActive = useRef(false);

  function onLogout() {
    setIsConnectionUnavailable(false);
    setUserIsLogin(false);
    removeLocalStorage("userToken");
    localStorage.removeItem("userId"); // remove userId from localStorage
    window.location.href = "/";
  }
  useEffect(() => {
    verificationActive.current = true;
    const timer = setInterval(() => {
      checkUserToken();
    }, 3000);
    return () => {
      verificationActive.current = false;
      clearInterval(timer);
    };
  }, []);
  useEffect(() => {
    const savedUserId = localStorage.getItem("userId"); // get userId from localStorage
    if (savedUserId) {
      setUserId(savedUserId); // initialize Recoil state with saved userId
    }
  }, []);

  const checkUserToken = async () => {
    if (verificationInFlight.current) return;
    verificationInFlight.current = true;
    try {
      const userToken = await getLocalStorage("userToken");
      if (!userToken) {
        if (verificationActive.current) setIsConnectionUnavailable(false);
        return;
      }
      const status = await checkTokenInterval(userToken);
      const currentToken = await getLocalStorage("userToken");
      if (!verificationActive.current || currentToken !== userToken) return;

      if (status === TOKEN_VERIFICATION_STATUS.EXPIRED) {
        onLogout();
      } else {
        setIsConnectionUnavailable(
          status === TOKEN_VERIFICATION_STATUS.UNAVAILABLE
        );
      }
    } catch {
      if (verificationActive.current) setIsConnectionUnavailable(true);
    } finally {
      verificationInFlight.current = false;
    }
  };

  useEffect(() => {
    checkAutoLogin(dispatch, props.history);
    checkUserIsLoigin();
  }, [dispatch, props.history]);

  const checkUserIsLoigin = async () => {
    const userToken = await getLocalStorage("userToken");
    const path = await getLocalStorage("path");
    if (userToken && path) {
      setUserIsLogin(true);
      props.history.push(path);
    }
  };

  let routes = (
    <Switch>
      <Route path="/" component={Login} />
      <Route path="/page-register" component={SignUp} />
      <Route path="/page-forgot-password" component={ForgotPassword} />
    </Switch>
  );
  if (userIsLogin) {
    return (
      <>
        {isConnectionUnavailable && (
          <div
            className="alert alert-warning mb-0 text-center shadow-sm"
            style={{ position: "fixed", bottom: 16, left: 16, right: 16, zIndex: 1100 }}
            role="status"
            aria-live="polite">
            サーバーに接続できません。接続を確認して、しばらくお待ちください。
          </div>
        )}
        <Suspense
          fallback={
            <div id="preloader">
              <div className="sk-three-bounce">
                <div className="sk-child sk-bounce1"></div>
                <div className="sk-child sk-bounce2"></div>
                <div className="sk-child sk-bounce3"></div>
              </div>
            </div>
          }>
          <Index />
        </Suspense>
      </>
    );
  } else {
    return (
      <div className="vh-100">
        <Suspense
          fallback={
            <div id="preloader">
              <div className="sk-three-bounce">
                <div className="sk-child sk-bounce1"></div>
                <div className="sk-child sk-bounce2"></div>
                <div className="sk-child sk-bounce3"></div>
              </div>
            </div>
          }>
          {routes}
        </Suspense>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: isAuthenticated(state),
  };
};

export default withRouter(connect(mapStateToProps)(App));
